import TrashcanIcon from "public/images/pricing/business/businessAutomateControl.svg";
import postIcon from "public/images/pricing/business/businessDeletePosts.svg";
import socialMediaSitesIcon from "public/images/pricing/business/businessMoreSocialMedia.svg";
import oldSocialMediaIcon from "public/images/pricing/business/businessOldSocialMedia.svg";
import newsHeadlineIcon from "public/images/pricing/business/businessAvoidHeadlines.svg";
import protectInfoIcon from "public/images/pricing/business/businessProtectInfo.svg";
import umbrellaIcon from "public/images/pricing/business/businessTakeProactive.svg";
import justiceWeighIcon from "public/images/pricing/business/businessPreventLawsuits.svg";
import Image from "next/image";

const Table = () => {
  return (
    <div className="flex w-full items-end justify-center">
      <div className="grid sm:grid-cols-2 grid-cols-1">
        <div className="flex flex-col w-[503px] h-[336px] ml-5 mt-5">
          <div className="flex flex-row items-center h-[60px] justify-start mt-0">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling posts"
                width={39}
                height={30}
                src={postIcon}
                className="flex items-center w-[39px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Delete your post, comments, likes, DMs and more! Across all major platforms
            </p>
          </div>
          <div className="flex flex-row items-center h-[60px] justify-start mt-7">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling major social media sites"
                width={29}
                height={30}
                src={socialMediaSitesIcon}
                className="flex items-center w-[29px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              40+ Major social media & direct messaging platforms supported
            </p>
          </div>
          <div className="flex flex-row items-center h-[60px] justify-start mt-7">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling dangers of old social media"
                width={29}
                height={30}
                src={oldSocialMediaIcon}
                className="flex items-center w-[29px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Old social media post are an attack vector for bad actors to target and gather
              information leaks
            </p>
          </div>
          <div className="flex flex-row items-center h-[60px] justify-start mt-7">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling dangers of old posts"
                width={29}
                height={30}
                src={newsHeadlineIcon}
                className="flex items-center w-[29px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Avoid unwanted headlines due to posting mishaps
            </p>
          </div>
        </div>

        <div className="flex flex-col w-[503px] h-[336px] ml-5 mt-5">
          <div className="flex flex-row items-center h-[60px] justify-start mt-0">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling of a trashcan"
                width={22}
                height={30}
                src={TrashcanIcon}
                className="flex items-center w-[22px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Automate control over your organizations social media
            </p>
          </div>
          <div className="flex flex-row items-center h-[60px] justify-start mt-7">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling of a lightbulb"
                width={30}
                height={30}
                src={protectInfoIcon}
                className="flex items-center w-[30px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Protect information leaks by using automatic keyword deletion
            </p>
          </div>
          <div className="flex flex-row items-center h-[60px] justify-start mt-7">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling of an umbrella"
                width={35}
                height={30}
                src={umbrellaIcon}
                className="flex items-center w-[35px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Take proactive steps stop online harrassment, bullying and brigading of your or & team
              members
            </p>
          </div>
          <div className="flex flex-row items-center h-[60px] justify-start mt-7">
            <div className="flex bg-brand-slate w-[60px] h-[60px] rounded-xl items-center justify-center shadow-black shadow-md">
              <Image
                alt="Icon resembling of a justice weigh"
                width={34}
                height={30}
                src={justiceWeighIcon}
                className="flex items-center w-[34px]"
              />
            </div>
            <p className="ml-5 w-[55%] sm:w-[411px]">
              Prevent copyright lawsuits using using automatic deletion
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
